// extracted by mini-css-extract-plugin
export default {"scrollToTopButton":"scrollToTopButton_tGbe","visible":"visible_YdMx"};